import React, { useState } from 'react';

function SecurityCenter() {
  const [expandedSection, setExpandedSection] = useState('lembaga');

  const toggleSection = (section) => {
    setExpandedSection(expandedSection === section ? null : section);
  };

  const sections = [
    {
      id: 'lembaga',
      title: 'Profil & Komitmen Lembaga',
      content: (
        <div className="space-y-4 text-xs sm:text-sm">
          <div className="bg-blue-50/50 border border-blue-100 rounded-2xl p-5 space-y-2">
            <h4 className="font-bold text-blue-900 uppercase text-xs tracking-wider">Yayasan Resmi</h4>
            <div className="grid gap-2 sm:grid-cols-2 text-xs">
              <div>
                <span className="text-slate-400">Nama Lembaga:</span>
                <p className="font-semibold text-blue-900">Yayasan Kunci Kemurnian Sejahtera (DT Peduli)</p>
              </div>
              <div>
                <span className="text-slate-400">Kontak Resmi:</span>
                <p className="font-semibold text-blue-900">0823 1900 0200 / support@dtpeduli.org</p>
              </div>
              <div className="sm:col-span-2">
                <span className="text-slate-400">Alamat Operasional:</span>
                <p className="font-semibold text-blue-900">Ruko Johar Grande, Jl. Johar Raya No.3, Tanah Sareal, Bogor, Jawa Barat</p>
              </div>
            </div>
          </div>

          <div className="bg-white border border-blue-100 rounded-2xl p-5 space-y-2">
            <h4 className="font-bold text-blue-900 uppercase text-xs tracking-wider">Komitmen Transparansi</h4>
            <ul className="space-y-2 text-xs text-slate-700">
              <li className="flex items-start gap-2">
                <span className="text-blue-900 font-bold">•</span>
                <span>Pengelolaan dana zakat, infak, dan sedekah sesuai prinsip syariah.</span>
              </li>
              <li className="flex items-start gap-2">
                <span className="text-blue-900 font-bold">•</span>
                <span>Pencatatan dan laporan penyaluran donasi yang dapat dipertanggungjawabkan.</span>
              </li>
              <li className="flex items-start gap-2">
                <span className="text-blue-900 font-bold">•</span>
                <span>Fokus pada mustahik, pemberdayaan dhuafa, dan bantuan darurat kebencanaan.</span>
              </li>
            </ul>
          </div>
        </div>
      )
    },
    {
      id: 'privasi',
      title: 'Kebijakan Privasi Data',
      content: (
        <div className="space-y-4 text-xs leading-relaxed text-slate-700">
          <p>
            Kami berkomitmen untuk melindungi kerahasiaan dan keamanan informasi pribadi Anda. Kebijakan privasi ini menjelaskan pengelolaan data pada sistem MPZ DT.
          </p>

          <div className="space-y-3">
            <div className="bg-white border border-blue-100 p-4 rounded-xl space-y-1">
              <h4 className="font-bold text-blue-900 text-xs">1. Informasi yang Dikumpulkan</h4>
              <p className="text-slate-600">Nama lengkap, alamat email, nomor telepon, riwayat transaksi donasi, dan bukti konfirmasi pembayaran.</p>
            </div>

            <div className="bg-white border border-blue-100 p-4 rounded-xl space-y-1">
              <h4 className="font-bold text-blue-900 text-xs">2. Penggunaan Informasi</h4>
              <p className="text-slate-600">Digunakan khusus untuk memproses donasi, menerbitkan kwitansi/laporan transaksi, dan komunikasi resmi terkait akun donatur.</p>
            </div>

            <div className="bg-white border border-blue-100 p-4 rounded-xl space-y-1">
              <h4 className="font-bold text-blue-900 text-xs">3. Perlindungan & Kerahasiaan Data</h4>
              <p className="text-slate-600">Sistem menggunakan standar enkripsi SSL/TLS dan pembatasan akses ketat. Kami tidak menjual atau membagikan data kepada pihak ketiga.</p>
            </div>
          </div>
        </div>
      )
    },
    {
      id: 'syarat',
      title: 'Syarat & Ketentuan Penggunaan',
      content: (
        <div className="space-y-4 text-xs leading-relaxed text-slate-700">
          <p>
            Dengan mendaftar dan berdonasi melalui aplikasi MPZ DT, Anda menyetujui ketentuan berikut:
          </p>

          <div className="space-y-3">
            <div className="bg-white border border-blue-100 p-4 rounded-xl space-y-1">
              <h4 className="font-bold text-blue-900 text-xs">1. Ketentuan Akun & Donasi</h4>
              <p className="text-slate-600">Setiap donatur bertanggung jawab atas kebenaran data akun dan nominal pembayaran yang disalurkan secara sukarela.</p>
            </div>

            <div className="bg-white border border-blue-100 p-4 rounded-xl space-y-1">
              <h4 className="font-bold text-blue-900 text-xs">2. Akuntabilitas Penyaluran</h4>
              <p className="text-slate-600">Lembaga menyalurkan donasi sesuai peruntukan program dan asas syariat Islam kepada penerima manfaat yang berhak.</p>
            </div>
          </div>
        </div>
      )
    },
    {
      id: 'password',
      title: 'Panduan Keamanan Akun & Kata Sandi',
      content: (
        <div className="space-y-4 text-xs text-slate-700">
          <div className="bg-amber-50/60 border border-amber-200 rounded-2xl p-5 space-y-2">
            <h4 className="font-bold text-amber-900 text-xs uppercase tracking-wider">Panduan Kata Sandi Aman</h4>
            <ul className="space-y-1.5 text-xs text-slate-700">
              <li className="flex items-start gap-2">
                <span className="text-amber-700 font-bold">•</span>
                <span>Gunakan kombinasi minimal 8 karakter dengan campuran huruf dan angka.</span>
              </li>
              <li className="flex items-start gap-2">
                <span className="text-amber-700 font-bold">•</span>
                <span>Hindari membagikan kata sandi atau kredensial akun kepada siapapun.</span>
              </li>
              <li className="flex items-start gap-2">
                <span className="text-amber-700 font-bold">•</span>
                <span>Perbarui kata sandi secara berkala melalui halaman Edit Profil.</span>
              </li>
            </ul>
          </div>
        </div>
      )
    }
  ];

  return (
    <div className="min-h-screen bg-slate-50 text-blue-900 pb-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 space-y-8">
        
        {/* Header Hero Banner */}
        <div className="relative overflow-hidden bg-gradient-to-r from-blue-950 via-blue-900 to-blue-900 rounded-3xl p-8 md:p-10 text-white shadow-md border border-blue-900 flex flex-col justify-between gap-4">
          <div className="max-w-3xl space-y-3">
            <span className="inline-flex items-center gap-2 px-3 py-1 rounded-full text-xs font-semibold bg-amber-400/20 text-amber-300 border border-amber-400/30 backdrop-blur-md">
              <span className="w-2 h-2 rounded-full bg-amber-400 animate-pulse"></span>
              MPZ DT • Proteksi & Ketentuan Syariat
            </span>
            <h1 className="text-3xl md:text-4xl font-extrabold tracking-tight">Keamanan & Privasi</h1>
            <p className="text-xs md:text-sm text-amber-100 leading-relaxed">
              Komitmen kami dalam mengelola data pribadi donatur dan transparansi tata kelola lembaga sesuai standar syariat.
            </p>
          </div>
        </div>

        {/* Tab Selection */}
        <div className="bg-white rounded-2xl border border-blue-100 p-4 shadow-sm">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-2">
            {sections.map((section) => (
              <button
                key={section.id}
                onClick={() => toggleSection(section.id)}
                className={`px-4 py-2.5 rounded-xl font-bold text-xs transition-all text-center ${
                  expandedSection === section.id
                    ? 'bg-blue-900 text-white shadow-sm'
                    : 'bg-slate-50 text-slate-700 border border-slate-200 hover:bg-white hover:border-blue-300'
                }`}
              >
                {section.title}
              </button>
            ))}
          </div>
        </div>

        {/* Detail Topik Terpilih */}
        <div className="space-y-6">
          {sections.map((section) => (
            expandedSection === section.id && (
              <div key={section.id} className="bg-white rounded-3xl border border-blue-100 p-6 md:p-8 shadow-sm space-y-5">
                <div className="pb-3 border-b border-blue-50">
                  <h2 className="text-lg font-bold text-blue-900">{section.title}</h2>
                </div>
                <div>
                  {section.content}
                </div>
              </div>
            )
          ))}
        </div>

      </div>
    </div>
  );
}

export default SecurityCenter;
